import metrics from 'maps/metrics';

export const tableHeaders = [
  { ...metrics['displayName'], label: 'Playlist' },
  { ...metrics['playlistTerritories'], label: 'Playlist\nTerritory' },
  { ...metrics['position'] },
  { ...metrics['customerId'] },
];

export const withChangeMetric = new Set([
  'displayName',
  'customerId',
  'position',
]);
